<template>
  <div>
    <h3 class="text-center">СЧЕТ / INVOICE</h3>
    <p class="text-center font-italic">
      номер счета / number: {{ invoice.DocumentNumber }}
    </p>
    <div class="my-2">
      <h5>ОТПРАВИТЕЛЬ/SENT BY</h5>
      <p>
        Название компании / Company Name: {{ seller.organizations.org_name }}
      </p>
      <p>
        Имя / Отдел Name / Department: {{ seller.persons.given_name }}
        {{ seller.persons.last_name }} / {{ seller.persons.position }}
      </p>
      <p>Адрес / Address: {{ seller.persons.post_address }}</p>
      <!-- <p>Город/Почт.Индекс/City/Postal Code:</p> -->
      <p>Страна / Country: {{ seller.persons.country }}</p>
      <p>Тел / Факс / Tel. / Fax: {{ seller.persons.person_phone_number }}</p>
      <!-- <p>Налоговый номер/VAT Reg. No:</p> -->
    </div>
    <div class="my-2">
      <h5>ПОЛУЧАТЕЛЬ / SENT TO</h5>
      <p>
        Название компании / Company Name: {{ buyer.organizations.org_name }}
      </p>
      <p>
        Имя / Отдел Name / Department: {{ buyer.persons.given_name }}
        {{ seller.persons.last_name }} / {{ seller.persons.position }}
      </p>
      <p>Адрес / Address: {{ buyer.persons.post_address }}</p>
      <!-- <p>Город/Почт.Индекс/City/Postal Code:</p> -->
      <p>Страна / Country: {{ buyer.persons.country }}</p>
      <p>Тел / Факс / Tel. / Fax: {{ buyer.persons.person_phone_number }}</p>
      <!-- <p>Налоговый номер/VAT Reg. No:</p> -->
    </div>
    <div class="my-2">
      <h5>
        Транспортный документ / WAYBILL / CMR / Bill of lading №{{ doc_id }}
      </h5>
      <div class="border border-black p-3">
        <p>
          Количество мест / Number of pieces: {{ invoice.PlacesQuantity }}
          {{ invoice.PlacesDescription }}
        </p>
        <p>
          Общий вес брутто / Total Gross Weight:
          {{ invoice.GrossWeightQuantity }}
        </p>
        <p>
          Общий вес нетто / Total Net Weight: {{ invoice.NetWeightQuantity }}
        </p>
        <p class="mb-0">Перевозчик/Carrier:</p>
      </div>
      <h5>Валюта инвойса / Currency of invoice: {{ currency }}</h5>
      <h5>Номер / Дата контракта / Number / Date of contract:</h5>
      <table class="table table-bordered" style="font-size: 11px">
        <tr>
          <th>Полное описание товаров / Full description of goods</th>
          <th>Таможенная спецификация / Customs Commodity Code</th>
          <th>Страна происхождения / Country of origin</th>
          <th>Количество / Quantity</th>
          <th>Цена за шт. / Unit value</th>
          <th>Общая стоимость / Sub Total Value</th>
        </tr>
        <tr v-for="(product, i) in invoice.product" :key="i">
          <td>{{ product.GoodsDescription }}</td>
          <td>{{ product.GoodsCode }}</td>
          <td>{{ product.OriginCountryCode }}</td>
          <td>{{ product.GoodsQuantity }}</td>
          <td>{{ product.Price }} {{ currency }}</td>
          <td>{{ product.Price * product.GoodsQuantity }} {{ currency }}</td>
        </tr>
      </table>
      <div class="w-50 ml-auto">
        <table class="table table-bordered">
          <tr>
            <td>Всего / Total Value FOB:</td>
            <td>{{ invoice.TotalCost }} {{ currency }}</td>
          </tr>
          <tr>
            <td>Ст-ть перевозки / Freight:</td>
            <td>{{ invoice.TransportCharges }} {{ currency }}</td>
          </tr>
          <tr>
            <td>Ст-ть страховки / Insurance:</td>
            <td>{{ invoice.InsuranceCharges }} {{ currency }}</td>
          </tr>
          <tr>
            <td class="font-weight-bold">Общая стоимость / Total Value CIF:</td>
            <td class="font-weight-bold">{{ invoice.GCost }} {{ currency }}</td>
          </tr>
        </table>
      </div>
      <div class="my-2 font-weight-bold w-50 ml-auto">
        Условия поставки (Инкотермс-2020) / Terms of Transportation
        (INCOTERMS-2020):
      </div>
      <p class="font-italic w-50 ml-auto">
        Подтверждаю, что все указанное верно / I declare that the above
        information is true and correct to the best of my knowledge.
      </p>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
</template>
<script>
import moment from "moment";
var QRCode = require("qrcode");
export default {
  props: ["user_id", "doc_id"],
  data() {
    return {
      оrganizations: {},
      xml: "",
      ecp_storage: "",
      document_number: "-",
      invoice: {},
      currencies: [],
      buyer: {
        organizations: {
          org_name: "",
        },
        persons: {
          given_name: "",
          last_name: "",
          position: "",
          post_address: "",
          country: "",
          person_phone_number: "",
          org_code: "",
        },
        org_residency: {
          display_text: "",
        },
      },
      seller: {
        organizations: {
          org_name: "",
        },
        persons: {
          given_name: "",
          last_name: "",
          position: "",
          post_address: "",
          country: "",
          person_phone_number: "",
          org_code: "",
        },
        org_residency: {
          display_text: "",
        },
      },
    };
  },
  mounted() {
    axios
      .get(
        window.base +
          "/library?type=currency&query=&qty=10000" +
          "&lang=" +
          this.$i18n.locale,
      )
      .then((response) => {
        this.currencies = response.data;
        axios
          .get(window.base + "/document/LoadInvoice?doc_id=" + this.doc_id)
          .then((response) => {
            this.invoice = response.data;
            axios
              .get(
                window.base +
                  "/document/getFirmbyBin?bin=" +
                  this.invoice.InvoiceByer,
              )
              .then((response) => {
                this.buyer = response.data;
                axios
                  .get(
                    window.base +
                      "/document/getFirmbyBin?bin=" +
                      this.invoice.InvoiceSeller,
                  )
                  .then((response) => {
                    this.seller = response.data;
                    axios
                      .get(window.base + "/contract/pdfNumber")
                      .then((response) => {
                        this.document_number = response.data;
                        axios
                          .get(
                            window.base +
                              "/document/LoadSignature?doc_id=" +
                              this.doc_id,
                          )
                          .then((response) => {
                            if (
                              typeof response.data.signature !== "undefined"
                            ) {
                              // console.log("as")
                              if (response.data.signature == "") {
                                this.$root.$emit("print-pdf", {
                                  signature: "",
                                  type: "invoice",
                                });
                                new Noty({
                                  theme: "light",
                                  type: "error",
                                  text: this.$t(
                                    "message.contracts.no-signature-message",
                                  ),
                                  timeout: 5000,
                                }).show();
                              } else {
                                var canvas = QRCode.toCanvas(
                                  response.data.signature,
                                  { width: 100, height: 100 },
                                );
                                canvas.then((r) => {
                                  // this.check_signature(value, ()=>{
                                  this.$root.$emit("print-pdf", {
                                    signature: r,
                                    type: "invoice",
                                  });
                                  new Noty({
                                    theme: "light",
                                    type: "success",
                                    text: this.$t(
                                      "message.contracts.yes-signature-message",
                                    ),
                                    timeout: 5000,
                                  }).show();
                                  // window.webSocket.removeEventListener('message', {})
                                  // })
                                });
                              }
                            } else {
                              // console.log("bs")
                              this.$root.$emit("print-pdf", {
                                signature: "",
                                type: "invoice",
                              });
                              new Noty({
                                theme: "light",
                                type: "error",
                                text: this.$t(
                                  "message.contracts.no-signature-message",
                                ),
                                timeout: 5000,
                              }).show();
                            }
                          });
                        /*axios.get(window.base + '/document/LoadInvoiceXML?doc_id='+this.doc_id).then(response=>{
                                this.xml = response.data.replace('<?xml version="1.0" encoding="utf-16"?>', '')
                                window.webSocket = new WebSocket('wss://127.0.0.1:13579/');
                                window.callback = null;

                                window.webSocket.onopen = (event)=>{
                                    console.log("Connection opened");
                                    // window.getKeyInfo("PKCS12", (r)=>{
                                    //     console.log('info', r)
                                    // })
                                    window.signXml("PKCS12", "SIGNATURE", this.xml, (tmp)=>{
                                        // console.log(tmp)
                                    });
                                };

                                window.webSocket.onclose = function (event) {
                                    if (event.wasClean) {
                                        console.log('connection has been closed');
                                    } else {
                                        console.log('Connection error');
                                        openDialog();
                                    }
                                    console.log('Code: ' + event.code + ' Reason: ' + event.reason);
                                };

                                window.webSocket.onmessage = (event) => {
                                    var result = JSON.parse(event.data);
                                    // console.log(result, event)
                                    if (result != null) {
                                        var rw = {
                                            code: result['code'],
                                            message: result['message'],
                                            responseObject: result['responseObject'],
                                            getResult: function () {
                                                return this.result;
                                            },
                                            getMessage: function () {
                                                return this.message;
                                            },
                                            getResponseObject: function () {
                                                return this.responseObject;
                                            },
                                            getCode: function () {
                                                return this.code;
                                            }
                                        };
                                        this.callback(rw)
                                    }
                                };
                            })*/
                      });
                  });
              });
          });
      });
  },
  methods: {
    /**
     * Checks if newly generated signature is similar to the one previously saved on the server.
     * If got true – everything ok, can download file, if false – then the document
     * has not been signed yet or has been changed after signing.
     */
    check_signature(signature, callback) {
      var fd = new FormData();
      fd.append("contract_id", this.doc_id);
      fd.append("signature", signature);
      axios.post(window.base + "/document/CheckSignature", fd).then((r) => {
        if (r.data == "False") {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.document_signature_is_wrong"),
            timeout: 5000,
          }).show();
        } else {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.document_signature_is_ok"),
            timeout: 5000,
          }).show();
          callback();
        }
      });
    },
    callback(r) {
      console.log(r);
      if (r.code == "200") {
        // console.log(r)
        var oParser = new DOMParser();
        var oDOM = oParser.parseFromString(
          r.getResponseObject(),
          "application/xml",
        );
        var value = oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
        var canvas = QRCode.toCanvas(value, { width: 100, height: 100 });
        canvas.then((r) => {
          this.check_signature(value, () => {
            this.$root.$emit("print-pdf", { signature: r, type: "invoice" });
            window.webSocket.close();
          });
        });
      }
    },
  },
  computed: {
    date() {
      return moment().format("D.MM.Y");
    },
    currency() {
      var c = "";
      if (typeof this.invoice.CurrencyCode !== "undefined")
        this.currencies.forEach((item) => {
          if (item.value == this.invoice.CurrencyCode.trim()) {
            c = item.display_text;
          }
        });
      return c;
    },
  },
};
</script>
